
import {Later} from 'utils/timers'
import ReasoningHead from './reasoning-head.vue'
import ReasoningList from './reasoning-list.vue'

const INIT_ITEMS = [{title: 'Thinking'}, {title: 'Planning'}]

export default {
  components: {
    ReasoningHead,
    ReasoningList
  },
  props: {
    reasoning: {type: Array, default: () => []},
    completed: {type: Boolean, required: true},
  },
  data() {
    return {
      open: false,
      later: new Later(5000),
      items: [INIT_ITEMS[0]]
    }
  },
  computed: {
    title() {
      return this.open ? 'Plan' : 'Show plan'
    },
    titled_reasoning() {
      // TODO: Remove mock titles once the API supplies a title for every item.
      return this.reasoning.map((item, index) => ({
        ...item,
        title: item.title || `Reasoning step ${index + 1}`
      }))
    }
  },
  watch: {
    'reasoning.length'(next, prev) {
      const diff = next - prev
      if (!diff) return
      this.later.abort()
      const new_items = this.titled_reasoning.slice(prev, next)
      this.items.push(...new_items)
    },
    completed(){
      if (this.completed) {
        this.open = false
      }
    }
  },
  beforeUnmount() {
    this.later.abort()
  },
  created(){
    if (this.completed) {
      this.items = [...INIT_ITEMS, ...this.titled_reasoning]
    }
    else if (this.reasoning.length) {
      this.items = [INIT_ITEMS[0], ...this.titled_reasoning]
    }
    else {
      const [, second_init] = INIT_ITEMS
      this.later.once(() => this.items.push(second_init))
    }
  },
}
